import { Row, Col, Card, CardBody, Modal, Button, ModalBody, Form, FormGroup, Input, Container } from 'reactstrap';
import React, { useEffect, useState, useRef, useCallback } from 'react'
import { toast } from "react-toastify";
import validator from "validator";
import Slider from "react-slick";
import { BsFillCheckCircleFill } from 'react-icons/bs';
import GoogleLogin from 'react-google-login';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import './style.css'
import _fetch from '../../_fetch';
import App1SVG from '../../assets/subscription/app-1.png'
import App2SVG from '../../assets/subscription/app-2.png'
import App3SVG from '../../assets/subscription/app-3.png'
import Flower1SVG from '../../assets/subscription/flower-1.svg'
import Flower2SVG from '../../assets/subscription/flower-2.svg'
import Flower3SVG from '../../assets/subscription/flower-3.svg'
import Flower4SVG from '../../assets/subscription/flower-4.svg'
import { LoginAction } from '../../actions/userActions';
import { footer_slide_data } from '../../components/Footers/footer_slide_data';
import Loader from "../../components/Loader/loader";
import AboutCoachSlider from '../../components/Sliders/AboutCoachSlider';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Header2 from '../../components/Headers/Header2';
import Footer from '../../components/Footers/AuthFooter';

export default function MagnetiseFitness() {
    const dispatch = useDispatch();
    const user = useSelector(st => st.user);
    const history = useHistory();
    const packagesRef = useRef(null);
    const {
        isComingFromPackage
    } = history.location.state || {};

    let monthlyProducts = [
        {
            name: 'BASIC PACKAGE',
            classes: '20',
            oldPrice: '150',
            price: '120',
            discount: '20',
            features: [
                {
                    type: 'text',
                    text: '20 new workout videos every month',
                },
                {
                    type: 'text',
                    text: 'The subscription will automatically renew until it is canceled. Payments are non-refundable.',
                },
                {
                    type: 'list',
                    text: 'Weekly Group Coaching Calls to include:',
                   items: [
                        '- Q&A',
                        '- Workout form correction & tips',
                        '- Nutrition Q&A & tips',
                        '- Collective subconscious healing sessions',
                        '- Meditation & breathwork',
                        '- Shadow healing topics',
                        ]

                },
                {
                    type: 'text',
                    text: 'WhatsApp private community.',
                },
                {
                    type: 'text',
                    text: '1 goal setting call for 30 min.',
                     bold:true
                },
            ]
        },
        {
            name: 'STANDARD PACKAGE',
            classes: '20',
            oldPrice: '200',
            price: '169',
            discount: '15',
            features: [
                {
                    type: 'text',
                    text: '20 new workout videos every month',
                },
                 {
                    type: 'text',
                    text: 'The subscription will automatically renew until it is canceled. Payments are non-refundable.',
                },
                {
                    type: 'list',
                    text: 'Weekly Group Coaching Calls to include:',
                    items: [
                            '- Q&A',
                            '- Workout form correction & tips',
                            '- Nutrition Q&A & tips',
                            '- Collective subconscious healing sessions',
                            '- Meditation & breathwork',
                            '- Shadow healing topics',
                            ]

                },
                {
                    type: 'text',
                    text: 'WhatsApp private community.',
                },
                {
                    type: 'text',
                    text: '1 Personalised Nutrition Call or Personal Training session.',
                    bold:true
                }
            ]
        },
        {
            name: 'PREMIUM PACKAGE',
            classes: '20',
            oldPrice: '275',
            price: '234',
            discount: '18',
            features: [
                {
                    type: 'text',
                    text: '20 new workout videos every month',
                },
                 {
                    type: 'text',
                    text: 'The subscription will automatically renew until it is canceled. Payments are non-refundable.',
                },
                 {
                    type: 'list',
                    text: 'Weekly Group Coaching Calls to include:',
                   items: [
                        '- Q&A',
                        '- Workout form correction & tips',
                        '- Nutrition Q&A & tips',
                        '- Collective subconscious healing sessions',
                        '- Meditation & breathwork',
                        '- Shadow healing topics',
                        ]

                },
                {
                    type: 'text',
                    text: 'WhatsApp private community.',
                },
                {
                    type: 'text',
                    text: '1 Personalised Nutrition Call or Personal Training session.',
                     bold:true
                },
                {
                    type: 'text',
                    text:'1 Personalised Subconscious Healing session with Tarot cards and energy cleansing',
                     bold:true
                }
            ]
        }
    ];
    const quaterlyProducts = [
        {
            name: 'BASIC PACKAGE',
            classes: '60',
            oldPrice: '420',
            price: '350',
            discount: '16',
            features: [
                {
                    type: 'text',
                    text: '60 new workout videos every quarter',
                },
                 {
                    type: 'text',
                    text: 'The subscription will automatically renew until it is canceled. Payments are non-refundable.',
                },
                {
                    type: 'list',
                    text: 'Weekly Group Coaching Calls to include:',
                   items: [
                        '- Q&A',
                        '- Workout form correction & tips',
                        '- Nutrition Q&A & tips',
                        '- Collective subconscious healing sessions',
                        '- Meditation & breathwork',
                        '- Shadow healing topics',
                        ]

                },
                {
                    type: 'text',
                    text: 'WhatsApp private community.',
                },
                {
                    type: 'text',
                    text: '1 goal setting call for 30 min.',
                     bold:true
                },
            ]
        },
        {
            name: 'STANDARD PACKAGE',
            classes: '60',
            oldPrice: '550',
            price: '500',
            discount: '9',
            features: [
                {
                    type: 'text',
                    text: '60 new workout videos every quarter',
                },
                 {
                    type: 'text',
                    text: 'The subscription will automatically renew until it is canceled. Payments are non-refundable.',
                },
                 {
                    type: 'list',
                    text: 'Weekly Group Coaching Calls to include:',
                   items: [
                        '- Q&A',
                        '- Workout form correction & tips',
                        '- Nutrition Q&A & tips',
                        '- Collective subconscious healing sessions',
                        '- Meditation & breathwork',
                        '- Shadow healing topics',
                        ]

                },
                {
                    type: 'text',
                    text: 'WhatsApp private community.',
                },
                {
                    type: 'text',
                    text: '1 Personalised Nutrition Call or Personal Training session.',
                    bold:true
                }
            ]
        },
        {
            name: 'PREMIUM PACKAGE',
            classes: '60',
            oldPrice: '775',
            price: '699',
            discount: '25',
            features: [
                {
                    type: 'text',
                    text: '60 new workout videos every quarter',
                },
                {
                    type: 'text',
                    text: 'Access to all workout categories',
                },
                 {
                    type: 'list',
                    text: 'Weekly Group Coaching Calls to include:',
                   items: [
                        '- Q&A',
                        '- Workout form correction & tips',
                        '- Nutrition Q&A & tips',
                        '- Collective subconscious healing sessions',
                        '- Meditation & breathwork',
                        '- Shadow healing topics',
                        ]

                },
                {
                    type: 'text',
                    text: 'WhatsApp private community.',
                },
                {
                    type: 'text',
                    text: '1 Personalised Nutrition Call or Personal Training session.',
                    bold:true
                },
                {
                    type: 'text',
                    text:'1 Personalised Subconscious Healing session with Tarot cards and energy cleansing',
                    bold:true
                }
            ]
        }
    ];

    const section2Features = [
        'Want sustainable fitness without punishment or extremes',
        'Struggle with consistency, motivation, or discipline',
        'Feel disconnected from your body',
        'Want to combine fitness with emotional & subconscious healing',
        'Are ready to embody strength from the inside out'
    ];

    const section4Features = [
    'Increased strength, stamina, and confidence',
    'Improved consistency and self-trust',
    'A calmer, more regulated nervous system',
    'Reduced self-sabotage around fitness and food',
    'A deeper, more compassionate relationship with your body',
    ];


    const section3Features = [
    {
        heading: 'Workout Video Library',
        points: [
        'Guided workout videos you can do at your own pace',
        'Strength, toning, mobility, and functional movement',
        'Designed to build consistency without burnout',
        'Suitable for different levels (modifications provided)',
        ],
    },
    {
        heading: 'Weekly Group Coaching Calls',
        points: [
        'Q&A (fitness, mindset, healing, integration)',
        'Workout form correction & technique tips',
        'Nutrition Q&A & nourishment guidance',
        'Collective subconscious healing sessions',
        'Meditation & breathwork for regulation and focus',
        'Shadow healing topics (self-sabotage, discipline blocks, body image, consistency, motivation)'
        ],
    },
    {
        heading: 'Subconscious & Shadow Work Integration',
        points: [
        'Self-sabotage patterns',
        'Inconsistency and motivation blocks',
        'Emotional eating or restriction cycles',
        'Body image wounds',
        'Nervous system overwhelm'
        ],
    },
        {
        heading: 'Meditation & Breathwork',
        points: [
        'Guided practices to calm the nervous system',
        'Breathwork to support energy, focus, and emotional release',
        'Tools you can use before workouts or in daily life'
        ],
    },
    ];


    var settings = {
        infinite: true,
        speed: 500,
        focusOnSelect: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,

                }
            },
            {
                breakpoint: 600,
                settings: {
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const award_pics = [
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award1.jpg`,
            caption: 'Outstanding Achievements in Business 2023 – Awarded by Honorable MP Bob Blackman, UK Parliament in collaboration with One Elements Organization'
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award.jpg`,
            caption: "'Remarkable Mentor’ by SheInspires Awards – May 2022 & 2023, awarded twice consecutively at UK Parliament by Honorable MP Bob Blackman"
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award2.jpeg`,
            caption: "Community Service award – Nov 22, At South Asian Women Leader Conference awarded by OneVision charity in the presence of Honorable MP Dean Russel, President of SAHA & Chief Inspector Police"
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award4.jpg`,
            caption: 'Business Community Leader – June 23 by EEL Professional Association for mentoring & supporting fellow small businesses.'
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award3.jpeg`,
            caption: 'British Fitness Awards – On the shortlist of top 25 Fitness Trainers of UK and KeepWell Mantras on the shortlist of Top 10 Sports groups of UK among circa 23000+ nominees'
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award6.jpeg`,
            caption: 'Mrs. & Ms. Asia Great Britain - Fitness mentor & Community engagement Lead for Beauty pageants'
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award5.jpeg`,
            caption: 'Frames of Mind, Newham Council – Regular volunteering for movement sessions for the Elderly'
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award7.jpeg`,
            caption: 'PerksAtWork –  One of the chosen Health & Wellness partners of a leading Corporate Employee Benefits company NextJump'
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award8.jpeg`,
            caption: 'SME British Made Awards 2023 - Best Fitness Entrepreneur'
        },
        {
            img: `${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/award9.jpeg`,
            caption: 'Health & Wellbeing 2024 - UK Parliament'
        }
    ];

    const [collapseOpen, setCollapseOpen] = useState(false);
    const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
    const [isInterestedModalOpen, setIsInterestedModalOpen] = useState(false);
    const [interestedUser, setInterestedUser] = useState({
        name: '',
        email: '',
        mobileNo: '',
        interestedFor: 'Core Sculpt Subscription',
    });
    const [loading, setLoading] = useState(false);
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [first_name, setFirstName] = useState('');
    const [last_name, setLastName] = useState('');
    const [_error, setError] = useState('');
    const [subscription, setSubscription] = useState(false);
    const location = useLocation();

    const pack_ref = useRef();


    const handleSubscribeNow = () => {
        // setIsInterestedModalOpen(true);
        // return;
        if (!user?._id) {
            setIsAccountModalOpen(true);
        } else {
            const url = `/magnetize-your-fitness/create/${user._id}`
            history.push(url);
        }
    }

    function googleLogin(response) {
        if (response.accessToken)
            setLoading(true);
        _fetch(process.env.REACT_APP_API + '/user/google', { method: "POST", body: { id_token: response.tokenObj.id_token } })
            .then(res => {
                if (res.success) {
                    dispatch(LoginAction(res.response));
                    history.push(`/magnetize-your-fitness/create/${res.response._id}`);
                } else {
                    toast.error(res.response);
                }
            })
            .catch(err => {
                console.log(err);
                toast.error('Some error occurred please try again later.')
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function googleLoginError(error) {
        if (error.error === 'idpiframe_initialization_failed') return;
        toast.error('Some error occurred please try again later');
    }

    function login(ev) {
        ev.preventDefault();

        if (!email || !validator.isEmail(email) || !password) return toast.error('Please enter valid email id');

        setLoading(true);

        _fetch(process.env.REACT_APP_API + '/user/login', { method: "POST", body: { email, password } })
            .then(res => {
                if (res.success) {
                    if (res.response.verified) {
                        dispatch(LoginAction(res.response));
                        history.push(`/magnetize-your-fitness/create/${res.response._id}`);
                    } else {
                        setOtpSent(true);
                        toast.success('OTP sent to your email id.');
                    }
                } else {
                    toast.error(res.response);
                }
            })
            .catch(err => {
                console.log(err);
                toast.error('Some error occurred please try again later.')
            })
            .finally(() => {
                setLoading(false);
            });

        return false;
    }

    function register(ev) {
        ev.preventDefault();

        if (!email || !validator.isEmail(email)) return toast.error('Please enter a valid email id');
        else if (!password || !validator.isStrongPassword(password)) return toast.error('Password must be at least 8 character long, and must have at least 1 lower case letter, 1 upper case letter, 1 number and 1 special symbol.');

        setLoading(true);

        _fetch(process.env.REACT_APP_API + '/user', { method: 'POST', body: { first_name, last_name, email, password } })
            .then(res => {
                if (res.success) {
                    setOtpSent(true);
                    toast.success(res.response.message);
                } else {
                    toast.error(res.response);
                }
            })
            .catch(err => {
                console.log(err);
                toast.error('Some error occurred please try again later.')
            })
            .finally(() => {
                setLoading(false);
            });

        return false;
    }

    async function verifyOTP(ev) {
        ev.preventDefault();
        if (!otp || otp.length !== 6) return toast.error('Please enter valid OTP');
        try {
            setLoading(true);
            let res = await _fetch(process.env.REACT_APP_API + '/user/verify-otp', { method: 'POST', body: { email, otp } });
            if (res.success) {
                toast.success('OTP verified successfully');
                dispatch(LoginAction(res.response));
                history.push(`/magnetize-your-fitness/create/${res.response._id}`);
            } else {
                toast.error(res.response);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    async function addInterestedUser(ev) {
        ev.preventDefault();
        try {
            setLoading(true);
            if (!interestedUser.name) setError('Please enter your name');
            else if (!interestedUser.email || !validator.isEmail(interestedUser.email)) setError('Please enter valid email id');
            else if (interestedUser.mobileNo && !validator.isMobilePhone(interestedUser.mobileNo)) setError('Please enter valid mobile number');
            else {
                let res = await _fetch(process.env.REACT_APP_API_V2 + '/interested-user', { method: 'POST', body: interestedUser });
                if (res.success) {
                    toast.success('Thank you for showing interest. We will get back to you soon.');
                    setInterestedUser({
                        name: '',
                        email: '',
                        mobileNo: '',
                        interestedFor: 'Core Sculpt Subscription',
                    });
                    setError('');
                    setIsInterestedModalOpen(false);
                } else {
                    setError(res.response);
                }
            }
        } catch (error) {
            console.log(error);
            setError('Some error occurred please try again later.');
        } finally {
            setLoading(false);
        }
    }

    const toggleCollapse = () => {
        setCollapseOpen((data) => !data);
    };

    useEffect(() => {
        if (isComingFromPackage) {
            packagesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            window.scrollTo(0, 0);
        }
    }, []);

    function _focus(ref) {
        if (ref?.current?.offsetTop) {
            window.scrollTo({
                left: 0,
                top: ref.current.offsetTop + 600,
                behavior: 'smooth'
            });
            console.log(ref.current.offsetTop)
        }
    }

    const _scroll = useCallback((ref) => {
        setTimeout(() => {
            console.log(ref?.current)
            _focus(ref);
        }, 500);
    }, []);

    useEffect(() => {
        if (location.hash) {
            if (location.hash.slice(1) === 'packages') {
                _scroll(pack_ref);
            }
        }
    }, [location.hash, _scroll]);

    return (
        <>
        <Header2 />
        <div
            className="subscription-page mobile-app-landing-page"
        >
            {/* <header className='px-2 px-lg-5 py-2'>
                <div className='d-flex align-items-center justify-content-between'>
                    <img src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/Core+Sculpt+Logo+Final.png`} alt=""
                        style={{
                            width: '150px',
                            objectFit: 'contain',
                            marginTop: '1%',
                        }}
                        className='logo-img'
                    />
                    <div className='d-none d-lg-flex align-items-center justify-content-end'>
                        <Link to='/home' className='menu-link mx-2'>Home</Link>
                        <Link to='/about' className='menu-link mx-2'>About</Link>
                        <Link to='/testimonials' className='menu-link mx-2'>Testimonials</Link>
                        <Link to='/recipes' className='menu-link mx-2'>Recipes</Link>
                        <Link to='/packages' className='menu-link mx-2'>Packages</Link>
                        <Link to='/classes' className='menu-link mx-2'>Class Schedule</Link>
                        <Link to='/client-transformation' className='menu-link mx-2'>Client Transformation</Link>
                        <Link to='/contact' className='menu-link mx-2'>Contact Us</Link>
                        <a href='#' onClick={handleSubscribeNow} className='join-now my-3'>
                            Join Now
                        </a>
                    </div>

                    <button
                        className="navbar-toggler d-lg-none d-block"
                        type="button"
                        onClick={toggleCollapse}
                    >
                        <i className="lni lni-menu"></i>
                    </button>

                </div>

                <div className={'d-flex d-lg-none mobile-menu-container ' + (collapseOpen ? 'mobile-visible' : '')}>
                    <div className='filler' onClick={toggleCollapse}></div>
                    <div className='mobile-menu'>
                        <div className='d-flex flex-column'>

                            <i className='lni lni-close close-icon' onClick={toggleCollapse} ></i>

                            <Link to='/home' className='menu-link mt-4 mb-3'>Home</Link>
                            <Link to='/about' className='menu-link my-3'>About</Link>
                            <Link to='/testimonials' className='menu-link my-3'>Testimonials</Link>
                            <Link to='/recipes' className='menu-link my-3'>Recipes</Link>
                            <Link to='/packages' className='menu-link my-3'>Packages</Link>
                            <Link to='/classes' className='menu-link my-3'>Class Schedule</Link>
                            <Link to='/client-transformation' className='menu-link my-3'>Client Transformation</Link>
                            <Link to='/contact' className='menu-link my-3'>Contact Us</Link>
                            <a href='#' onClick={handleSubscribeNow} className='join-now my-3'>
                                Join Now
                            </a>
                        </div>
                    </div>
                </div>

            </header> */}
            <div
                className="subscription-feature-section section-1 d-flex flex-column align-items-center justify-content-between"
                style={{
                    backgroundColor: '#ffffff',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        padding: '3%',
                        zIndex: '2',
                        flex: '1',
                        maxHeight: '80%',
                    }}
                    className='content-container d-flex flex-column justify-content-around align-items-center'
                >
                    <h1
                        style={{
                            fontWeight: '500',
                            fontSize: '40px',
                            color: '#292929',
                            fontFamily: 'Forum, cursive',
                            textAlign: 'center',
                        }}
                        className='d-md-block d-none'
                    >Magnetize Your Fitness</h1>
                     <h1
                        style={{
                            fontWeight: '500',
                            fontSize: '40px',
                            color: '#292929',
                            fontFamily: 'Forum, cursive',
                            textAlign: 'center',
                            paddingBottom: '3%',
                        }}
                        className='d-md-none'
                    >Magnetize Your Fitness</h1>
                    <h3
                        style={{
                            fontWeight: '600',
                            fontSize: '20px',
                            color: '#00adef',
                            textAlign: 'center',
                        }}
                        className='d-md-block d-none'
                    >
                        A holistic fitness program membership for body, subconscious mind & energetic alignment
                    </h3>
                     <h3
                        style={{
                            fontWeight: '600',
                            fontSize: '20px',
                            color: '#00adef',
                            textAlign: 'center',
                            paddingBottom: '3%',
                        }}
                        className='d-md-none'
                    >
                        A holistic fitness program membership for body, subconscious mind & energetic alignment
                    </h3>
                    <p
                        style={{
                            fontSize: '13px',
                            color: '#000000',
                            fontWeight: '400',
                            textAlign: 'center',
                        }}
                        className='content-description'
                    >
                        Magnetize Your Fitness is led by Prapti Dutt, Level 4 Qualified Fitness Trainer, Nutritionist, and Shadow Healer, with experience supporting thousands of transformations worldwide. <br/> <br/>

                        These are not surface-level results. This work creates inside-out transformations — where physical change is supported by nervous system regulation, subconscious healing, and sustainable habits. Nutrition guidance is not a restrictive meal plan approach, but education and guidance to help you make aligned, supportive choices for your body and lifestyle.<br/> <br/>

                        The focus is not quick fixes, restriction, or punishment — but long-term strength, confidence, and alignment with your body.
                    </p>
                    <div
                        className='d-flex flex-column flex-md-row justify-content-center align-items-center'
                    >
                        <button
                            style={{
                                color: 'white',
                                fontWeight: 'bold',
                                backgroundColor: '#212529',
                                border: 'none',
                                borderRadius: '0px 15px 0px 15px',
                                padding: '10px 20px',
                                margin: '0px 10px',
                                width: '200px',
                                height: '100%'
                            }}
                            className='mt-1 subscription-button'
                            onClick={() => _scroll(pack_ref)}
                        >
                            Subscribe Now
                        </button>
                    </div>
                     <div
                        style={{
                            width: '80%',
                            height: '250px',
                            position: 'relative',
                        }}
                        className='d-md-none'
                    >
                        <div
                            style={{
                                width: '100%',
                                height: '80%',
                                backgroundColor: '#e0e0f9',
                                position: 'absolute',
                                bottom: '0',
                                borderRadius: '0px 50px 0px 50px',
                                zIndex: '1',
                            }}
                            className='img-background-2'
                        />
                        <img
                            src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/myf-1-new.png`}
                            alt=""
                            style={{
                                height: '100%',
                                position: 'absolute',
                                bottom: '0',
                                zIndex: '2',
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                        />
                    </div>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        height: '80%',
                        width: '20%',
                        transform: 'translateY(-50%)',
                        zIndex: '1',
                        right: '0',
                        marginLeft: '1%',
                    }}
                    className='d-flex flex-column justify-content-around flower-img-container'
                >
                    {/* <img
                        src={Flower1SVG}
                        alt=""
                        style={{
                            width: '40%',
                            objectFit: 'contain',
                            marginLeft: '55%'
                        }}
                        className='flower-1-svg'
                    /> */}
                    <div
                        style={{
                            width: '100%',
                            height: '40%',
                            position: 'relative',
                        }}
                    >
                        <div
                            style={{
                                width: '100%',
                                height: '80%',
                                backgroundColor: '#FEF0E3',
                                position: 'absolute',
                                bottom: '0',
                                borderRadius: '0px 50px 0px 50px',
                                zIndex: '1',
                            }}
                            className='img-background-2'
                        />
                        <img
                            src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/myf-2-new.png`}
                            alt=""
                            style={{
                                height: '100%',
                                position: 'absolute',
                                bottom: '0',
                                zIndex: '2',
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                        />
                    </div>
                    {/* <img
                        src={Flower2SVG}
                        alt=""
                        style={{
                            width: '40%',
                            objectFit: 'contain',
                        }}
                        className='flower-1-svg'
                    /> */}
                </div>
                
                {/* <img
                    src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/myf-2-new.png`}
                    alt=""
                    style={{
                        position: 'absolute',
                        right: '0',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        objectFit: 'contain',
                        zIndex: '1',
                        width: '15%',
                        marginRight: '1%',
                    }}
                    className='app-3-svg'
                /> */}
                <div className='d-none d-md-block'>
 <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        height: '80%',
                        width: '20%',
                        transform: 'translateY(-50%)',
                        zIndex: '1',
                        left: '0',
                        marginLeft: '1%',
                    }}
                    className='d-flex flex-column justify-content-around flower-img-container'
                >
                    <img
                        src={Flower1SVG}
                        alt=""
                        style={{
                            width: '40%',
                            objectFit: 'contain',
                            marginLeft: '55%'
                        }}
                        className='flower-1-svg'
                    />
                    <div
                        style={{
                            width: '100%',
                            height: '40%',
                            position: 'relative',
                        }}
                    >
                        <div
                            style={{
                                width: '100%',
                                height: '80%',
                                backgroundColor: '#e0e0f9',
                                position: 'absolute',
                                bottom: '0',
                                borderRadius: '0px 50px 0px 50px',
                                zIndex: '1',
                            }}
                            className='img-background-2'
                        />
                        <img
                            src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/myf-3-new.png`}
                            alt=""
                            style={{
                                height: '100%',
                                position: 'absolute',
                                bottom: '0',
                                zIndex: '2',
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                        />
                    </div>
                    <img
                        src={Flower2SVG}
                        alt=""
                        style={{
                            width: '40%',
                            objectFit: 'contain',
                        }}
                        className='flower-1-svg'
                    />
                </div>
                </div>
               
            </div> 
                         <div
                className="subscription-feature-section section-2"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Row
                    className='w-100 features'
                    style={{
                        padding: '0% 15%',
                        position: 'relative',
                        flex: '1',
                        overflow: 'hidden',
                        margin: '0',
                    }}
                    xs='1'
                    md='2'
                >
                    <Col
                        className='h-100 d-flex justify-content-end app-img-container'
                        style={{
                            order: '1',
                        }}
                    >
                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                position: 'relative',
                            }}
                            className='img-container'
                        >
                            <div
                                className='img-background'
                                style={{
                                    position: 'absolute',
                                    height: '90%',
                                    width: '90%',
                                    left: '0',
                                    top: '0',
                                    backgroundColor: '#E4D0F4',
                                    borderRadius: '40px 0px 40px 0px',
                                    zIndex: '1',
                                }}
                            />
                            <img
                                className='actual-img'
                                src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/myf-2.jpg`}
                                alt=""
                                style={{
                                    height: '90%',
                                    width: '90%',
                                    objectFit: 'cover',
                                    position: 'absolute',
                                    right: '0',
                                    bottom: '0',
                                    borderRadius: '40px 0px 40px 0px',
                                    zIndex: '2',
                                }}
                            />
                            <img
                                src={Flower3SVG}
                                alt=""
                                style={{
                                    width: '20%',
                                    position: 'absolute',
                                    top: '15%',
                                    right: '0',
                                    objectFit: 'contain',
                                    transform: 'translateX(50%)',
                                    maxWidth: '250px',
                                    zIndex: '3',
                                }}
                            />
                        </div>
                    </Col>
                    <Col
                        className='h-100 content-container d-flex flex-column justify-content-center align-items-start content-container'
                        style={{
                            padding: '5%',
                            order: '2',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: 'transparent',
                                zIndex: '2',
                            }}
                        >
                            <h1
                                style={{
                                    color: '#212529',
                                    fontSize: '50px',
                                    fontWeight: '500',
                                    fontFamily: 'Forum, cursive',
                                }}
                            >
                                 This membership is for you if you:
                            </h1>
                            {/* <p
                                style={{
                                    color: '#212529',
                                    fontWeight: '400',
                                    fontSize: '13px',
                                }}
                            >
                                This membership is for you if you:
                            </p> */}
                            <div
                                className='d-flex flex-column'
                            >
                                {
                                    section2Features.map((feature, index) => (
                                        <div
                                            className='d-flex align-items-center list-item-container my-1'
                                        >
                                            <BsFillCheckCircleFill className='text-md mr-3 flex-shrink-0' style={{
                                                color: '#212529',
                                            }} />
                                            <p
                                                className='list-item'
                                                style={{
                                                    padding: '0',
                                                    margin: '0',
                                                    fontSize: '13px',
                                                    color: '#212529'
                                                }}
                                            >
                                                {feature}
                                            </p>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </Col>
                    <img
                        src={Flower2SVG}
                        alt=""
                        style={{
                            width: '10%',
                            position: 'absolute',
                            top: '0',
                            right: '0',
                            objectFit: 'contain',
                            margin: '2.5%',
                            maxWidth: '200px',
                            minWidth: '80px',
                            zIndex: '1',
                        }}
                    />
                </Row>
            </div> 
             <div
                className="section-5" ref={pack_ref}
            >
                <div
                    className="d-flex justify-content-center align-items-center content-container"
                    style={{
                        width: '100%',
                        padding: '2% 10%',
                        overflow: 'hidden',
                        backgroundColor: '#e4d0f4',
                        marginTop: '50px',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#FFFFFF',
                            height: '100%',
                            width: '100%',
                            borderRadius: '0px 60px 0px 60px',
                            padding: '7%',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                        className='d-flex flex-column justify-content-center align-items-center content-container-inner'
                    >
                        <img
                            src={Flower1SVG}
                            alt=""
                            style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                width: '15%',
                                objectFit: 'contain',
                                zIndex: '1',
                                minWidth: '80px',
                                maxWidth: '200px',
                                transform: 'translate(-20%, -20%)',
                            }}
                        />
                        <img
                            src={Flower2SVG}
                            alt=""
                            style={{
                                position: 'absolute',
                                bottom: '0',
                                right: '0',
                                width: '15%',
                                objectFit: 'contain',
                                zIndex: '1',
                                minWidth: '80px',
                                maxWidth: '200px',
                                transform: 'translate(20%, 20%)',
                            }}
                        />
                        <h2
                            style={{
                                fontWeight: '500',
                                fontFamily: 'Forum,cursive',
                                color: '#212529',
                                textAlign: 'center',
                                fontSize: '30px',
                                lineHeight: '1',
                                zIndex: '2',
                            }}
                        >
                            What Members Get
                        </h2>
                        <p
                            style={{
                                fontWeight: '300',
                                color: '#212529',
                                textAlign: 'center',
                                fontSize: '20px',
                                padding: '0',
                                margin: '0',
                                zIndex: '2',
                            }}
                        >
                            Members often experience increased strength, stamina, and confidence alongside improved consistency and self-trust. Many notice a calmer, more regulated nervous system, reduced self-sabotage around fitness and food, and a deeper, more compassionate relationship with their body.
                        </p>
                        <p
                            style={{
                                fontWeight: '600',
                                color: '#212529',
                                textAlign: 'center',
                                fontSize: '20px',
                                padding: '0',
                                margin: '0',
                                zIndex: '2',
                            }}
                        >
                            Magnetize your fitness with Prapti Dutt!
                        </p>
                    </div>
                </div>

                <div
                    style={{
                        minHeight: '10vh',
                        width: '100%',
                    }}
                    className='d-flex justify-content-center align-items-center'
                >


                </div>
            </div>
            <div
                className="subscription-feature-section section-3"
                style={{
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Row
                    className='w-100 h-100 features'
                    style={{
                        padding: '5% 10%',
                        overflow: 'hidden',
                        margin: '0',
                        position: 'relative',
                    }}
                >
                    <Col
                        xs='12'
                        md='12'
                        className='h-100 d-flex flex-column justify-content-center content-container'
                        style={{
                            order: '1',
                            padding: '5%',
                            position: 'relative',
                            zIndex: '1'
                        }}
                    >
                        <img
                            src={Flower2SVG}
                            alt=""
                            style={{
                                position: 'absolute',
                                top: '0',
                                right: '0',
                                width: '10%',
                                maxWidth: '200px',
                                minWidth: '80px',
                                zIndex: '-1',
                            }}
                        />
                        <h2
                            style={{
                                fontWeight: '500',
                                fontSize: '30px',
                                color: '#1D1D1D',
                                zIndex: '2',
                                fontFamily: 'Forum, cursive',
                            }}
                        >
                            What’s Included
                        </h2>
                        <p
                            style={{
                                fontWeight: '400',
                                color: '#8C8C8C',
                                fontSize: '15px',

                            }}
                        >
                            Magnetize Your Fitness is not just a workout program — it’s a transformational membership that blends physical training, nutrition support, nervous system regulation and subconscious healing..
                        </p>
                        <Row
                            xs='1'
                            md='2'
                        >
                          {
  section3Features.map((group, groupIndex) => (
    <Col key={groupIndex} className="mb-4">
      
      {/* Card */}
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '0px 50px 0px 50px', // top-right & bottom-left
          padding: '20px',
          height: '100%',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06)',
          border: '1px solid #E5E5E5',
        }}
      >
        {/* Heading */}
        <p
          style={{
            fontWeight: '600',
            color: '#1A1A1A',
            marginBottom: '12px',
          }}
        >
          {group.heading}
        </p>

        {/* Points */}
        {group.points.map((feature, index) => (
          <div
            key={index}
            className="d-flex list-item-container my-2"
          >
            <BsFillCheckCircleFill
              className="text-md mr-3 flex-shrink-0"
              style={{ color: '#1A1A1A', marginTop: '6px' }}
            />

            <p
              className="list-item"
              style={{
                padding: '0',
                margin: '0',
                color: '#292929',
                fontWeight: '300',
              }}
            >
              {feature}
            </p>
          </div>
        ))}
      </div>

    </Col>
  ))
}



                        </Row>
                    </Col>
                </Row>

            </div>

            <div
                className="section-5" ref={pack_ref}
            >
                <div
                    className="d-flex justify-content-center align-items-center content-container"
                    style={{
                        width: '100%',
                        padding: '2% 10%',
                        overflow: 'hidden',
                        backgroundColor: '#e4d0f4',
                        marginTop: '50px',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#FFFFFF',
                            height: '100%',
                            width: '100%',
                            borderRadius: '0px 60px 0px 60px',
                            padding: '7%',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                        className='d-flex flex-column justify-content-center align-items-center content-container-inner'
                    >
                        <img
                            src={Flower1SVG}
                            alt=""
                            style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                width: '15%',
                                objectFit: 'contain',
                                zIndex: '1',
                                minWidth: '80px',
                                maxWidth: '200px',
                                transform: 'translate(-20%, -20%)',
                            }}
                        />
                        <img
                            src={Flower2SVG}
                            alt=""
                            style={{
                                position: 'absolute',
                                bottom: '0',
                                right: '0',
                                width: '15%',
                                objectFit: 'contain',
                                zIndex: '1',
                                minWidth: '80px',
                                maxWidth: '200px',
                                transform: 'translate(20%, 20%)',
                            }}
                        />
                        <h2
                            style={{
                                fontWeight: '500',
                                fontFamily: 'Forum,cursive',
                                color: '#212529',
                                textAlign: 'center',
                                fontSize: '30px',
                                lineHeight: '1',
                                zIndex: '2',
                            }}
                        >
                            Magnetize your Fitness by Prapti Dutt
                        </h2>
                        <p
                            style={{
                                fontWeight: '300',
                                color: '#212529',
                                textAlign: 'center',
                                fontSize: '20px',
                                padding: '0',
                                margin: '0',
                                zIndex: '2',
                            }}
                        >
                            Unleash the Iron power of your Core with me using<br />the Ultimate Machine – Your own Body!
                        </p>
                        <p
                            style={{
                                fontWeight: '600',
                                color: '#212529',
                                textAlign: 'center',
                                fontSize: '20px',
                                padding: '0',
                                margin: '0',
                                zIndex: '2',
                            }}
                        >
                            Magnetize your fitness with Prapti Dutt!
                        </p>
                    </div>
                </div>
                <div
                    style={{
                        padding: '1% 5%',
                    }}
                    className='d-flex flex-column justify-content-center align-items-center'
                    ref={packagesRef}
                    id='packages'
                >
                    <h2
                        style={{
                            color: '#212529',
                            fontSize: '35px',
                            fontWeight: '500',
                            fontFamily: 'Forum, cursive',
                            textAlign: 'center',
                        }}
                    >
                        Ready to Magnetize Your Fitness?
                    </h2>
                </div>
                <div
                    className='d-flex flex-column justify-content-center align-items-center mt-4'
                >
                    <div style={{
                        display: "flex", backgroundColor: '#E4E4E460',
                        borderRadius: '100px', overflow: "hidden", gap: '5px', fontWeight: '500',
                        maxWidth: '100%'
                    }}
                    >
                        <div
                            className={`${!subscription ? 'bgr' : ''}`}
                            style={{
                                padding: '15px 30px', borderRadius: '100px', alignItems: 'center',
                                display: 'flex', justifyContent: 'center', cursor: 'pointer'
                            }}
                            onClick={() => setSubscription(false)}
                        >
                            Monthly</div>
                        <div className={`${subscription ? 'bgl' : ''}`}
                            style={{
                                padding: '15px 30px', borderRadius: '100px', alignItems: 'center',
                                display: 'flex', justifyContent: 'center', cursor: 'pointer'
                            }}
                            onClick={() => setSubscription(true)}
                        >
                            Quarterly</div>
                    </div>
                </div>

                {
                    !subscription
                        ?
                        <Row
                            className={`w-100 features product-container ${monthlyProducts.length === 2 ? 'product-container-len-2' : 'product-container-len-3'}`}
                            xs='1'
                            md={monthlyProducts.length}
                            style={{
                                padding: '1% 5%',
                                margin: '0',
                                overflow: 'hidden',
                            }}
                        >
                            {
                                monthlyProducts.map((product, index) => (
                                    <Col
                                        className='h-100 py-3'
                                    >
                                        <Card
                                            key={index}
                                            className='h-100 product-card'
                                            style={{
                                                borderRadius: '0px 60px 0px 60px',
                                                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
                                                border: '2px solid #808080',
                                                overflow: 'hidden',
                                                backgroundColor: index % 2 === 0 ? '#ffffff' : '#faf4ff',
                                            }}
                                        >
                                            <CardBody className='px-4 py-6'>
                                                <div>
                                                    <h3
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '1rem',
                                                            margin: '0px',
                                                            textDecoration: 'line-through',
                                                        }}
                                                    >
                                                        £{product.oldPrice} /month
                                                    </h3>
                                                    <h1
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '1.5rem',
                                                            margin: '0px',
                                                            fontFamily: 'Forum, cursive'
                                                        }}
                                                    >
                                                        £{product.price} /month
                                                    </h1>

                                                    <h3
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '0.8rem',
                                                            margin: '0px',
                                                            fontFamily: 'Forum, cursive'
                                                        }}
                                                    >
                                                        {product.name}
                                                    </h3>
                                                    <div>
                                                        <span
                                                            className='mr-2'
                                                            style={{
                                                                fontSize: '0.8rem',
                                                            }}
                                                        >
                                                            {product.classes} videos
                                                        </span>
                                                        <span
                                                            style={{
                                                                color: '#c58bf2',
                                                                fontWeight: 'bold',
                                                                fontSize: '0.8rem',
                                                            }}
                                                        >
                                                            /MONTH
                                                        </span>
                                                    </div>
                                                </div>
                                                <div
                                                    className='pt-3'
                                                >
                                                    <h3
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '0.8rem',
                                                        }}
                                                    >
                                                        Included in your subscription
                                                    </h3>
                                                    <hr className='my-1' />
                                                    {
                                                        product.features.map((feature, index) => (
                                                            feature.type === 'text' ? (
                                                                <div className='d-flex flex-row'>
                                                                    <BsFillCheckCircleFill className='text-sm mr-2 mt-1 flex-shrink-0' style={{
                                                                        color: '#c58bf2',
                                                                    }} />
                                                                   <p
                                                                        className="subscription-features-bullet-point text-sm"
                                                                        style={{
                                                                            fontWeight: feature.bold ? 600 : 400,
                                                                        }}
                                                                        >
                                                                        {feature.text}
                                                                        </p>
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className='d-flex flex-column'
                                                                >
                                                                    <div className='d-flex flex-row'>
                                                                        <BsFillCheckCircleFill className='text-sm mr-2 mt-1 flex-shrink-0' style={{
                                                                            color: '#c58bf2',
                                                                        }} />
                                                                        <p className='subscription-features-bullet-point text-sm'>{
                                                                            feature.text
                                                                        }</p>
                                                                    </div>
                                                                    <div
                                                                        className='d-flex flex-column pl-4'
                                                                    >
                                                                        {
                                                                            feature.items.map((item, index) => (
                                                                                <div className='d-flex flex-row'>
                                                                                    <BsFillCheckCircleFill className='text-sm mr-2 mt-1 flex-shrink-0' style={{
                                                                                        color: '#c58bf2',
                                                                                    }} />
                                                                                    <p className='subscription-features-bullet-point text-sm'>{
                                                                                        item
                                                                                    }</p>
                                                                                </div>
                                                                            ))
                                                                        }

                                                                    </div>
                                                                </div>
                                                            )
                                                        ))
                                                    }
                                                    <button
                                                        style={{
                                                            fontWeight: '500',
                                                            color: '#FFFFFF',
                                                            backgroundColor: '#212529',
                                                            border: 'none',
                                                            borderRadius: '0px 15px 0px 15px',
                                                            padding: '12px 40px',
                                                            flexGrow: '0',
                                                            marginTop: '4%',
                                                            width: '100%',
                                                        }}
                                                        className='subscription-button-product'
                                                        onClick={handleSubscribeNow}
                                                    >
                                                        Subscribe Now
                                                    </button>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))
                            }
                        </Row>
                        :
                        <Row
                            className={`w-100 features product-container ${quaterlyProducts.length === 2 ? 'product-container-len-2' : 'product-container-len-3'}`}
                            xs='1'
                            md={quaterlyProducts.length}
                            style={{
                                padding: '1% 5%',
                                margin: '0',
                                overflow: 'hidden',
                            }}
                        >
                            {
                                quaterlyProducts.map((product, index) => (
                                    <Col
                                        className='h-100 py-3'
                                    >
                                        <Card
                                            key={index}
                                            className='h-100 product-card'
                                            style={{
                                                borderRadius: '0px 60px 0px 60px',
                                                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
                                                border: '2px solid #808080',
                                                overflow: 'hidden',
                                                backgroundColor: index % 2 === 0 ? '#ffffff' : '#faf4ff',
                                            }}
                                        >
                                            <CardBody className='px-4 py-6'>
                                                <div>
                                                    <h3
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '1rem',
                                                            margin: '0px',
                                                            textDecoration: 'line-through',
                                                        }}
                                                    >
                                                        £{product.oldPrice} /quarter
                                                    </h3>
                                                    <h1
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '1.5rem',
                                                            margin: '0px',
                                                            fontFamily: 'Forum, cursive'
                                                        }}
                                                    >
                                                        £{product.price} /quarter
                                                    </h1>

                                                    <h3
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '0.8rem',
                                                            margin: '0px',
                                                            fontFamily: 'Forum, cursive'
                                                        }}
                                                    >
                                                        {product.name}
                                                    </h3>
                                                    <div>
                                                        <span
                                                            className='mr-2'
                                                            style={{
                                                                fontSize: '0.8rem',
                                                            }}
                                                        >
                                                            {product.classes} videos
                                                        </span>
                                                        <span
                                                            style={{
                                                                color: '#c58bf2',
                                                                fontWeight: 'bold',
                                                                fontSize: '0.8rem',
                                                            }}
                                                        >
                                                            /QUARTER
                                                        </span>
                                                    </div>
                                                </div>
                                                <div
                                                    className='pt-3'
                                                >
                                                    <h3
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: '0.8rem',
                                                        }}
                                                    >
                                                        Included in your subscription
                                                    </h3>
                                                    <hr className='my-1' />
                                                    {
                                                        product.features.map((feature, index) => (
                                                            feature.type === 'text' ? (
                                                                <div className='d-flex flex-row'>
                                                                    <BsFillCheckCircleFill className='text-sm mr-2 mt-1 flex-shrink-0' style={{
                                                                        color: '#c58bf2',
                                                                    }} />
                                                                   <p
                                                                        className="subscription-features-bullet-point text-sm"
                                                                        style={{
                                                                            fontWeight: feature.bold ? 600 : 400,
                                                                        }}
                                                                        >
                                                                        {feature.text}
                                                                        </p>

                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className='d-flex flex-column'
                                                                >
                                                                    <div className='d-flex flex-row'>
                                                                        <BsFillCheckCircleFill className='text-sm mr-2 mt-1 flex-shrink-0' style={{
                                                                            color: '#c58bf2',
                                                                        }} />
                                                                        <p className='subscription-features-bullet-point text-sm'>{
                                                                            feature.text
                                                                        }</p>
                                                                    </div>
                                                                    <div
                                                                        className='d-flex flex-column pl-4'
                                                                    >
                                                                        {
                                                                            feature.items.map((item, index) => (
                                                                                <div className='d-flex flex-row'>
                                                                                    <BsFillCheckCircleFill className='text-sm mr-2 mt-1 flex-shrink-0' style={{
                                                                                        color: '#c58bf2',
                                                                                    }} />
                                                                                    <p className='subscription-features-bullet-point text-sm'>{
                                                                                        item
                                                                                    }</p>
                                                                                </div>
                                                                            ))
                                                                        }

                                                                    </div>
                                                                </div>
                                                            )
                                                        ))
                                                    }
                                                    <button
                                                        style={{
                                                            fontWeight: '500',
                                                            color: '#FFFFFF',
                                                            backgroundColor: '#212529',
                                                            border: 'none',
                                                            borderRadius: '0px 15px 0px 15px',
                                                            padding: '12px 40px',
                                                            flexGrow: '0',
                                                            marginTop: '4%',
                                                            width: '100%',
                                                        }}
                                                        className='subscription-button-product'
                                                        onClick={handleSubscribeNow}
                                                    >
                                                        Subscribe Now
                                                    </button>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))
                            }
                        </Row>
                }

                <div
                    style={{
                        minHeight: '10vh',
                        width: '100%',
                    }}
                    className='d-flex justify-content-center align-items-center'
                >


                </div>
            </div>
            {/* <div
                className="section-6 d-flex flex-column justify-content-space-between align-items-center"
                style={{
                    backgroundColor: '#ffffff',
                    justifyContent: 'space-between',
                }}
            >
                <Container
                    className='mb-5'
                >
                    <Row>
                        <Col xs="12">
                            <h2
                                style={{
                                    color: '#212529',
                                    fontSize: '35px',
                                    fontWeight: '500',
                                    fontFamily: 'Forum, cursive',
                                    textAlign: 'center',
                                }}
                            >
                                Awards & Accolades
                            </h2>
                        </Col>

                        <Col xs={12}>
                            <AboutCoachSlider
                                settings={settings}
                                images={award_pics}
                            />
                        </Col>
                    </Row>
                </Container>
                <div
                    style={{
                        width: '100%',
                        overflow: 'hidden',
                    }}
                >
                    <Slider
                        dots={false} infinite={true} slidesToScroll={1} speed={500} autoplay={true} autoplaySpeed={3000}
                        slidesToShow={6} pauseOnHover={true}
                        prevArrow={<div><i className="lni lni-chevron-left"></i></div>}
                        nextArrow={<div><i className="lni lni-chevron-right"></i></div>}

                    >
                        {
                            footer_slide_data.map(e => (
                                <div key={e.name}>
                                    <img src={e.banner} alt="" className='img img-fluid' />
                                </div>
                            ))
                        }
                    </Slider>
                </div>
            </div> */}
            <Modal
                isOpen={isAccountModalOpen}
                toggle={() => {
                    setIsAccountModalOpen(!isAccountModalOpen);
                }}
                centered={true}
                size='lg'
                className='account-modal'
            >
                <ModalBody>
                    <Row
                        className='p-2'
                    >
                        <Col
                            xs='12'
                            md='6'
                            className='d-flex flex-column justify-content-center align-items-center'
                        >
                            <img src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/Core+Sculpt+Logo+Final.png`} alt=""
                                style={{
                                    width: '120px',
                                    objectFit: 'contain',
                                }}
                                className='logo-img'
                            />
                            <h3
                                style={{
                                    fontWeight: '600',
                                    fontFamily: 'Forum, cursive',
                                }}
                                className='my-3'
                            >
                                Welcome to CoreSculpt
                            </h3>
                            <GoogleLogin
                                clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}
                                buttonText="Login"
                                onSuccess={googleLogin}
                                onFailure={googleLoginError}
                                cookiePolicy={'single_host_origin'}
                                scopes='profile'
                                render={renderProps => (
                                    <Button
                                        className="btn-icon flex-fill mx-0 w-100 common-field-box"
                                        onClick={renderProps.onClick}
                                        style={{
                                            width: '100%',
                                            borderRadius: '12px',
                                            color: 'black',
                                            backgroundColor: '#ffffff',
                                            boxShadow: 'none',
                                            border: '2px solid #ececec',
                                        }}
                                    >
                                        <span className="btn-inner--icon">
                                            <img
                                                alt="Login With Google"
                                                src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/google.svg`}
                                            />
                                        </span>
                                        <span className="btn-inner--text">Continue with Google</span>
                                    </Button>
                                )}
                                autoLoad={false}
                            />
                            <Button
                                className="flex-fill my-2 mx-0 w-100 common-field-box"
                                onClick={() => {
                                    setIsLogin(!isLogin)
                                    setOtpSent(false);
                                }}
                            >
                                <span className="btn-inner--text">{
                                    isLogin ? 'Create an Account' : 'Login'
                                }</span>
                            </Button>
                            <div
                                style={{
                                    width: '100%',
                                    borderTop: '2px solid #ececec',
                                    position: 'relative',
                                }}
                                className='d-flex justify-content-center align-items-center my-2'
                            >
                                <p
                                    style={{
                                        position: 'absolute',
                                        top: '0',
                                        transform: 'translateY(-50%)',
                                        margin: '0',
                                        color: '#212529',
                                        backgroundColor: '#ffffff',
                                        padding: '0 10px',
                                    }}
                                >
                                    Or
                                </p>
                            </div>
                            {
                                isLogin ? (
                                    <Form
                                        className='w-100'
                                        onSubmit={
                                            otpSent ? verifyOTP : login
                                        }
                                    >
                                        {
                                            otpSent ? (
                                                <React.Fragment>
                                                    <p
                                                        style={{
                                                            fontSize: 14,
                                                            fontWeight: 400,
                                                            color: '#212529',
                                                            marginBottom: 20,
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        We have sent an OTP to your email address. Please enter the OTP below to verify your email address.
                                                    </p>
                                                    <FormGroup
                                                        className='my-2 w-100'
                                                    >
                                                        <Input
                                                            type="text"
                                                            name="otp"
                                                            id="otp"
                                                            placeholder="OTP"
                                                            onChange={(e) => {
                                                                setOtp(e.target.value);
                                                            }}
                                                            className='common-field-box'
                                                            value={otp}
                                                        />
                                                    </FormGroup>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <FormGroup
                                                        className='my-2 w-100'
                                                    >
                                                        <Input
                                                            type="email"
                                                            name="email"
                                                            id="email"
                                                            placeholder="Email"
                                                            onChange={(e) => {
                                                                setEmail(e.target.value);
                                                            }}
                                                            className='common-field-box'
                                                            value={email}
                                                        />
                                                    </FormGroup>
                                                    <FormGroup
                                                        className='my-2 w-100'
                                                    >
                                                        <Input
                                                            type="password"
                                                            name="password"
                                                            id="password"
                                                            placeholder="Password"
                                                            onChange={(e) => {
                                                                setPassword(e.target.value);
                                                            }}
                                                            className='common-field-box'
                                                            value={password}
                                                        />
                                                    </FormGroup>
                                                </React.Fragment>
                                            )
                                        }
                                        {
                                            loading ? (
                                                <div
                                                    className='w-100 py-2 my-2 d-flex justify-content-center align-items-center continue-btn-field-box'
                                                >
                                                    <Loader
                                                        size={25}
                                                        thickness={0.1}
                                                    />
                                                </div>
                                            ) : (
                                                <Button
                                                    className='w-100 my-2 continue-btn-field-box'
                                                    type='submit'
                                                    onSubmit={
                                                        otpSent ? verifyOTP : login
                                                    }
                                                >
                                                    Continue
                                                </Button>
                                            )
                                        }
                                    </Form>
                                ) : (
                                    <Form
                                        className='w-100'
                                        onSubmit={
                                            otpSent ? verifyOTP : register
                                        }
                                    >
                                        {
                                            otpSent ? (
                                                <React.Fragment>
                                                    <p
                                                        style={{
                                                            fontSize: 14,
                                                            fontWeight: 400,
                                                            color: '#212529',
                                                            marginBottom: 20,
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        We have sent an OTP to your email address. Please enter the OTP below to verify your email address.
                                                    </p>
                                                    <FormGroup
                                                        className='my-2 w-100'
                                                    >
                                                        <Input
                                                            type="text"
                                                            name="otp"
                                                            id="otp"
                                                            placeholder="OTP"
                                                            onChange={(e) => {
                                                                setOtp(e.target.value);
                                                            }}
                                                            className='common-field-box'
                                                            value={otp}
                                                        />
                                                    </FormGroup>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <FormGroup
                                                        className='my-2 w-100'
                                                    >
                                                        <Input
                                                            type="text"
                                                            name="first_name"
                                                            id="first_name"
                                                            placeholder="First Name"
                                                            onChange={(e) => {
                                                                setFirstName(e.target.value);
                                                            }}
                                                            className='common-field-box'
                                                            value={first_name}
                                                        />
                                                    </FormGroup>
                                                    <FormGroup
                                                        className='my-2 w-100'
                                                    >
                                                        <Input
                                                            type="text"
                                                            name="last_name"
                                                            id="last_name"
                                                            placeholder="Last Name"
                                                            onChange={(e) => {
                                                                setLastName(e.target.value);
                                                            }}
                                                            className='common-field-box'
                                                            value={last_name}
                                                        />
                                                    </FormGroup>
                                                    <FormGroup
                                                        className='my-2 w-100'
                                                    >
                                                        <Input
                                                            type="email"
                                                            name="email"
                                                            id="email"
                                                            placeholder="Email"
                                                            onChange={(e) => {
                                                                setEmail(e.target.value);
                                                            }}
                                                            className='common-field-box'
                                                            value={email}
                                                        />
                                                    </FormGroup>
                                                    <FormGroup
                                                        className='my-2 w-100'
                                                    >
                                                        <Input
                                                            type="password"
                                                            name="password"
                                                            id="password"
                                                            placeholder="Password"
                                                            onChange={(e) => {
                                                                setPassword(e.target.value);
                                                            }}
                                                            className='common-field-box'
                                                            value={password}
                                                        />
                                                    </FormGroup>
                                                    <span
                                                        className='d-block text-center w-100 m-0'
                                                        style={{
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        By signing up, you agree to our <a href="/terms" target="_blank">Terms & Conditions</a> and <a href="/privacy" target="_blank">Privacy Policy</a>.
                                                    </span>
                                                </React.Fragment>
                                            )
                                        }
                                        {
                                            loading ? (
                                                <div
                                                    className='w-100 py-2 my-2 d-flex justify-content-center align-items-center continue-btn-field-box'
                                                >
                                                    <Loader
                                                        size={25}
                                                        thickness={0.1}
                                                    />
                                                </div>
                                            ) : (
                                                <Button
                                                    className='w-100 my-2 continue-btn-field-box'
                                                    type='submit'
                                                    onSubmit={
                                                        otpSent ? verifyOTP : register
                                                    }
                                                >
                                                    Continue
                                                </Button>
                                            )
                                        }
                                    </Form>
                                )
                            }
                        </Col>
                        <Col
                            xs='0'
                            md='6'
                            className='img-container overflow-hidden'
                        >
                            <div
                                className='w-100 h-100 position-relative'
                            >
                                <div
                                    style={{
                                        width: '90%',
                                        height: '90%',
                                        position: 'absolute',
                                        top: '0',
                                        left: '0',
                                        backgroundColor: '#E4D0F4',
                                        borderRadius: '80px 0px 80px 0px',
                                        zIndex: '1',
                                    }}
                                    className='underlay'
                                />
                                <img
                                    src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/Section-6-Img.jpg`}
                                    alt=""
                                    style={{
                                        height: '90%',
                                        width: '90%',
                                        objectFit: 'cover',
                                        position: 'absolute',
                                        bottom: '0',
                                        right: '0',
                                        borderRadius: '80px 0px 80px 0px',
                                        zIndex: '2',
                                    }}
                                    className='overlay-img'
                                />

                            </div>
                        </Col>
                    </Row>
                </ModalBody>

            </Modal>
            <Modal
                isOpen={isInterestedModalOpen}
                toggle={() => {
                    setIsInterestedModalOpen(!isInterestedModalOpen);
                }}
                centered={true}
                size='lg'
                className='interested-user-modal'
            >
                <ModalBody>
                    <Row
                        className='p-2'
                        style={{
                            minHeight: '60vh'
                        }}
                    >
                        <Col
                            xs='12'
                            md='6'
                            className='d-flex flex-column justify-content-center align-items-center'
                        >
                            <img src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/Core+Sculpt+Logo+Final.png`} alt=""
                                style={{
                                    width: '120px',
                                    objectFit: 'contain',
                                }}
                                className='logo-img'
                            />
                            <h3
                                style={{
                                    fontWeight: '600',
                                    fontFamily: 'Forum, cursive',
                                }}
                                className='my-3'
                            >
                                Welcome to CoreSculpt
                            </h3>
                            <Form
                                className='w-100'
                                onSubmit={addInterestedUser}
                            >
                                <React.Fragment>
                                    <p
                                        style={{
                                            fontSize: 14,
                                            fontWeight: 400,
                                            color: '#212529',
                                            marginBottom: 20,
                                            textAlign: 'center'
                                        }}
                                    >
                                        So glad to see you here! Please enter your details below to get notified when we launch.
                                    </p>
                                    <FormGroup
                                        className='my-2 w-100'
                                    >
                                        <Input
                                            type="text"
                                            name="name"
                                            id="name"
                                            placeholder="Name"
                                            onChange={(e) => {
                                                setInterestedUser({
                                                    ...interestedUser,
                                                    name: e.target.value,
                                                });
                                            }}
                                            className='common-field-box'
                                            value={interestedUser.name}
                                        />
                                    </FormGroup>
                                    <FormGroup
                                        className='my-2 w-100'
                                    >
                                        <Input
                                            type="email"
                                            name="email"
                                            id="email"
                                            placeholder="Email"
                                            onChange={(e) => {
                                                setInterestedUser({
                                                    ...interestedUser,
                                                    email: e.target.value,
                                                });
                                            }}
                                            className='common-field-box'
                                            value={interestedUser.email}
                                        />
                                    </FormGroup>
                                    <FormGroup
                                        className='my-2 w-100'
                                    >
                                        <Input
                                            type="tel"
                                            name="mobileNo"
                                            id="mobileNo"
                                            placeholder="Mobile No."
                                            onChange={(e) => {
                                                setInterestedUser({
                                                    ...interestedUser,
                                                    mobileNo: e.target.value,
                                                });
                                            }}
                                            className='common-field-box'
                                            value={interestedUser.mobileNo}
                                        />
                                    </FormGroup>
                                </React.Fragment>
                                <span
                                    style={{
                                        fontSize: 16,
                                        fontWeight: 400,
                                        color: 'red',
                                    }}
                                >
                                    {_error}
                                </span>
                                {
                                    loading ? (
                                        <div
                                            className='w-100 py-2 my-2 d-flex justify-content-center align-items-center continue-btn-field-box'
                                        >
                                            <Loader
                                                size={25}
                                                thickness={0.1}
                                            />
                                        </div>
                                    ) : (
                                        <Button
                                            className='w-100 my-2 continue-btn-field-box'
                                            type='submit'
                                            onSubmit={addInterestedUser}
                                        >
                                            Continue
                                        </Button>
                                    )
                                }
                            </Form>
                        </Col>
                        <Col
                            xs='0'
                            md='6'
                            className='img-container overflow-hidden'
                        >
                            <div
                                className='w-100 h-100 position-relative'
                            >
                                <div
                                    style={{
                                        width: '90%',
                                        height: '90%',
                                        position: 'absolute',
                                        top: '0',
                                        left: '0',
                                        backgroundColor: '#E4D0F4',
                                        borderRadius: '80px 0px 80px 0px',
                                        zIndex: '1',
                                    }}
                                    className='underlay'
                                />
                                <img
                                    src={`${process.env.REACT_APP_AWS_BUCKET_PUBLIC}/kwm_web/Section-6-Img.jpg`}
                                    alt=""
                                    style={{
                                        height: '90%',
                                        width: '90%',
                                        objectFit: 'cover',
                                        position: 'absolute',
                                        bottom: '0',
                                        right: '0',
                                        borderRadius: '80px 0px 80px 0px',
                                        zIndex: '2',
                                    }}
                                    className='overlay-img'
                                />

                            </div>
                        </Col>
                    </Row>
                </ModalBody>

            </Modal>

        </div >
        <Footer />
        </>
    );
}